import { render } from "./main.vue?vue&type=template&id=335e1dfa&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=335e1dfa&lang=scss&scoped=true"
import "./main.vue?vue&type=style&index=1&id=335e1dfa&lang=scss"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335e1dfa"]])

export default __exports__